export enum InventoryItemStatusEnum {
  ACTIVE = 1,
  ARCHIVED = 2,
}

export enum InventoryMovementTypeEnum {
  RECEIVE = 1,
  USAGE = 2,
  WASTE = 3,
  ADJUST = 4,
}

export enum InventoryUnitEnum {
  KG = 'kg',
  G = 'g',
  L = 'l',
  ML = 'ml',
  PCS = 'pcs',
  BOX = 'box',
}
